import { isTouch } from './detect';

interface ShareData {
    text?: string;
    title?: string;
    url?: string;
}

export enum SharingMethod {
    CLIPBOARD = 'clipboard',
    SHARE_API = 'shareApi',
}

export async function share(data: ShareData): Promise<SharingMethod> {
    const url = data.url ? new URL(data.url, document.baseURI).href : '';
    if ('share' in window.navigator && isTouch()) {
        await window?.navigator.share({
            text: `${data.text}\n\n${url}`,
            title: data.title,
        });

        return SharingMethod.SHARE_API;
    }

    if ('clipboard' in window.navigator) {
        const text = [data.title, data.text, url].filter(Boolean).join('\n');

        await navigator.clipboard.writeText(text);

        return SharingMethod.CLIPBOARD;
    }

    throw new Error('Share API is not supported');
}
